import { trimObjectValues, valueToNumber } from '@/utilz';
import { YES_NO_OPTIONS } from '@/contants/common';
import { isNumber } from '@/utils/number';

import { getDefaultTMSSettings, type TMSSettings, type TMSSettingsApi } from '../../models';

export const normalizeTmsSettings = (apiData?: TMSSettingsApi): TMSSettings => {
  const data = apiData?.customerKey ? trimObjectValues(apiData) : getDefaultTMSSettings();
  return {
    auctionSettings: {
      bidExpiryNoOfDays: data?.bidExpiryNoOfDays,
      defaultCargoType: data?.defaultCargoType,
      defaultEquipmentType: data?.defaultEquipmentType,
      disableExpiredBids: data?.disableExpiredBids,
      isReverseAuction: data?.isReverseAuction,
      maxBidHours: data?.maxBidHours,
    },
    companySettings: {
      brokerageCustomer: data?.brokerageCustomer,
      statusInTMS: data?.statusInTMS,
    },
    povSettings: {
      allowDraftShipments: data?.allowDraftShipments,
      allowIncoCode: data?.allowIncoCode || '',
      defaultClass: data?.defaultClass,
      defaultFobCode: data?.defaultFobCode,
      defaultPackageUom: data?.defaultPackageUom,
      defaultUom: data?.defaultUom,
      isCatchDate: data?.isCatchDate,
      isPoItemLocation: data?.isPoItemLocation,
      maximumDays: data?.maximumDays,
      maximumDaysErrorMsg: data?.maximumDaysErrorMsg,
      minimumDays: data?.minimumDays,
      minimumDaysErrorMsg: data?.minimumDaysErrorMsg,
      numberOfRoutingCarrierReturned: data?.numberOfRoutingCarrierReturned,
      poValidationFlag: data?.poValidationFlag,
      povDestinationMethod: data?.povDestinationMethod,
      routingMethod: data?.routingMethod,
      shipmentIdAlphaPrefix: data?.shipmentIdAlphaPrefix,
      shipmentIdStartingInteger: data?.shipmentIdStartingInteger,
      shipmentTermsAllowed: data?.shipmentTermsAllowed,
    },
    shipmentSettings: {
      adminEmail: data?.adminEmail,
      autoRate: data?.autoRate,
      autoTender: data?.autoTender,
      autoTenderAmount: data?.autoTenderAmount,
      autoTenderCargoType: data?.autoTenderCargoType === 'N' ? null : data?.autoTenderCargoType,
      defaultBranchKey: valueToNumber(data?.defaultBranchKey),
      defaultBusinessJustification: data?.defaultBusinessJustification,
      defaultFreightClass: data?.defaultFreightClass,
      defaultHazmat: data?.defaultHazmat,
      defaultHeight: data?.defaultHeight,
      defaultIncoTerm: data?.defaultIncoTerm,
      defaultLen: data?.defaultLen,
      defaultProdDesc: data?.defaultProdDesc,
      defaultProductCode: data?.defaultProductCode,
      defaultRatingPreferencevalue: data?.defaultRatingPreferencevalue,
      defaultShipmentTerms: data?.defaultShipmentTerms,
      defaultShipmentType: data?.defaultShipmentType,
      defaultSpotBidEndStatus: data?.defaultSpotBidEndStatus,
      defaultWidth: data?.defaultWidth,
      displayPO_SOOnShipmentLevel: data?.displayPO_SOOnShipmentLevel,
      emailFrom: data?.emailFrom,
      enableMasterOrders: data?.enableMasterOrders,
      isBillToVisible: data?.isBillToVisible,
      isCategoryToValidate: data?.isCategoryToValidate,
      isCategoryVisible: data?.isCategoryVisible,
      isDefaultRatingPreference: data?.isDefaultRatingPreference,
      isRequiredApprovalNumber: data?.isRequiredApprovalNumber,
      isShowRatingDetails: data?.isShowRatingDetails,
      isVendorVisible: data?.isVendorVisible,
      isvisiablePaidBy: data?.isvisiablePaidBy,
      isWeightCalculation: data?.isWeightCalculation,
      nextID: data?.nextID,
      pricingType: data?.pricingType,
      qtyTolerancePercentage: data?.qtyTolerancePercentage,
      recalculateFreightClass: isNumber(data?.recalculateFreightClass) && data?.recalculateFreightClass > 0 ? 'Y' : 'N',
      routingGuideMatch: data?.routingGuideMatch,
      shipmentApprovalCount: data?.shipmentApprovalCount,
      shipmentApprovalRequired: data?.shipmentApprovalRequired,
      shipmentEmailAttachment: data?.shipmentEmailAttachment,
      shipmentSupportMail: data?.shipmentSupportMail,
    },
    supplierModuleSettings: {
      earlyShipmentRestrictionDetails: data?.earlyShipmentRestrictionDetails || [],
      isAllowEarlyShipmentRestriction: data?.isAllowEarlyShipmentRestriction || YES_NO_OPTIONS?.[1]?.value,
    },
  };
};
